import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GoogleAnalyticsConsent } from "./google-analytics-consent";
import { StageApp } from "./stage-app";
import "./stage-app.css";
import "./studio-player.css";
import "./recording-player.css";
import "./captain-cameo.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StageApp
      legalDockAction={
        <GoogleAnalyticsConsent
          measurementId={import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID}
          settingsPlacement="inline"
        />
      }
    />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then((registration) => registration.update());
  });
}
